import apiClient from "./apiClient";

export const refreshToken = async () => {
  const refresh_token = localStorage.getItem("refresh_token");
  const user_id = localStorage.getItem("user_id");
  const { data } = await apiClient.post("/biu-chatbot/refreshtoken", {
    refresh_token,
    user_id,
  });

  // Save the new values
  localStorage.setItem("session_token", data.token);
  localStorage.setItem("refresh_token", data.refreshToken);
  return data.token;
};
 